import { Component, OnInit } from '@angular/core';
import {RutasFuncionalidades} from '../../../_enums/enum';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Funcionalidad} from '../../../_models/funcionalidad';
import {HomologacionPlanCargo} from '../../../_models/homologacion-plan-cargo';
import {forkJoin} from 'rxjs';
import {PlanCargoService} from '../../../_services/plan-cargo.service';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {HomologacionPlanCargoService} from '../../../_services/homologacion-plan-cargo.service';
import {NavService} from '../../../_services/_nav.service';
import { ListaService } from '../../../_services/lista.service';
import { ListaItem } from '../../../_models/lista-item';

@Component({
  selector: 'app-homologacion-planes-cargos-editar',
  templateUrl: './homologacion-planes-cargos-editar.component.html',
  styleUrls: ['./homologacion-planes-cargos-editar.component.css']
})
export class HomologacionPlanesCargosEditarComponent implements OnInit {

  carInformacionInicial = true;
  formulario: FormGroup;
  funcionalidad: Funcionalidad = new Funcionalidad();
  submitted = false;
  homologacionPlanCargo: HomologacionPlanCargo;
  lisPlanesCargos: SelectItem[] = [];
  lisPlanesCargosAplicables: any[] = [];
  guardando = false;
  banAccion: boolean = false;
  existe: any;
  lisPlanCargoComodin: SelectItem[] = [];




  constructor( private authService: AutenticacionService,
               private fb: FormBuilder,
               private route: ActivatedRoute,
               private planCargoService: PlanCargoService,
               private navService: NavService,
               private confirmationService: ConfirmationService,
               private router: Router,
               private homologacionPlanCargoService: HomologacionPlanCargoService,
               private lisServicio: ListaService
  ) { }

  ngOnInit() {
    this.route.params.subscribe( async( params: Params ) => {
      this.banAccion = !!params[ 'id' ]
      if ( this.banAccion ) {
        this.homologacionPlanCargo = await this.homologacionPlanCargoService.obtenerPorId(params['id']).toPromise();
      }
      this.cargaInicial();
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      planCargoProducto: [ this.homologacionPlanCargo ? this.homologacionPlanCargo.idPlanCargoProducto : null , [ Validators.required ], ],
      idComodinPlanCargo: [ this.homologacionPlanCargo ? this.homologacionPlanCargo.idComodinPlanCargo : null, [ Validators.required ], ],
      codigoShivam: [ this.homologacionPlanCargo ? this.homologacionPlanCargo.codigoShivam : null, [ Validators.required ] ],
    });
    this.carInformacionInicial = false;
  }


  get f() {
    return this.formulario.controls;
  }

  cargaInicial() {
    const mn = this.authService.obtenerFuncionalidades().find((x) => x.ruta === RutasFuncionalidades.HOMOLOGACIONPLANCARGO);
    if (mn) {
      this.funcionalidad = mn;
    }

    forkJoin(this.planCargoService.listadoHabilitados(), this.lisServicio.getMasterDetails('ListasComodinPlanesCargo')).subscribe( ([planesCargos, lisPlanCargoComodin]) => {
      this.lisPlanesCargos = [];
      this.lisPlanesCargosAplicables = planesCargos;
      planesCargos.forEach( ( s) => {
        this.lisPlanesCargos.push( { label: s.nombre, value: s.idPlanCargo } );
      } );
      lisPlanCargoComodin.map((s: ListaItem) => {
        this.lisPlanCargoComodin.push({ label: s.nombre, value: s.idLista });
      });
      this.cargarFormulario();
    });
  }

  cancelar( fDirty: boolean ): void {
    if (fDirty) {
      this.confirmationService.confirm({
        message: ` ¿Está seguro que desea cancelar los cambios realizados?`,
        header: 'Confirmación',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate(['apl/homologacion-plan-cargo']);
        }
      });
    } else {
      this.router.navigate(['apl/homologacion-plan-cargo']);
    }
  }

  async onSubmit() {
    this.submitted = true;
    if (!this.formulario.valid) {
      return;
    }
    this.guardando = true;
    const homologacionPlanCargo = this.obtenerHomologacionPlanCargo();
    this.existe = await this.homologacionPlanCargoService.validarDobleRegistroAlmacenado(homologacionPlanCargo.idPlanCargoProducto, homologacionPlanCargo.idComodinPlanCargo).toPromise();
    if (this.existe && !this.banAccion) {
      this.mostrarMensajeInformacion();
    } else {
      const resultado = await this.guardarHomologacionPlanCargo(homologacionPlanCargo);
      this.actualizarEstado(resultado.idHomologacionPlanCargo ? 2 : 1);
      this.router.navigate(['apl/homologacion-plan-cargo']);
    }
    this.reiniciarEstado();
  }

  obtenerHomologacionPlanCargo(): HomologacionPlanCargo {
    const data = this.formulario.getRawValue();
    const homologacionPlanCargo = this.homologacionPlanCargo || {} as HomologacionPlanCargo;
    homologacionPlanCargo.idPlanCargoProducto = data.planCargoProducto;
    homologacionPlanCargo.idComodinPlanCargo = data.idComodinPlanCargo;
    homologacionPlanCargo.codigoShivam = data.codigoShivam;
    homologacionPlanCargo.indicadorHabilitado = true;
    return homologacionPlanCargo;
  }
  async guardarHomologacionPlanCargo(homologacionPlanCargo: HomologacionPlanCargo): Promise<HomologacionPlanCargo> {
    if (homologacionPlanCargo.idHomologacionPlanCargo && this.existe) {
      homologacionPlanCargo.idHomologacionPlanCargo = this.existe.idHomologacionPlanCargo;
      return this.homologacionPlanCargoService.actualizar(homologacionPlanCargo).toPromise();
    }
    return this.homologacionPlanCargoService.crear(homologacionPlanCargo).toPromise();
  }

  mostrarMensajeInformacion() {
    this.navService.setMesage(0, {
      severity: 'info',
      summary: this.navService.buscarMensaje('LBL_INFORMACION'),
      detail: this.navService.buscarMensaje('HOMOLOGACIONPLANESCARGOS.LBL_COMBINACION'),
    });
  }

  actualizarEstado(mensaje: number) {
    this.navService.setMesage(mensaje);
    this.formulario.markAsPristine();
  }

  reiniciarEstado() {
    this.guardando = false;
    this.submitted = false;
  }
}
